import React, { useState } from "react";
import { usePreviewEngine } from "./usePreviewEngine";
import { FiSettings } from "react-icons/fi";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
} from "@/components/ui/shadcn/dropdown-menu";

export function PreviewPane() {
  const { canvasRef } = usePreviewEngine();
  const [showSafeArea, setShowSafeArea] = useState(true);

  return (
    <div className="flex-1 self-stretch h-full min-h-0 flex items-center justify-center overflow-hidden relative">
      <div 
        className="relative w-full h-full min-h-0 flex items-center justify-center max-w-full max-h-full"
      >
        <div className='relative border border-secondary/50 h-full max-h-full flex items-center'>
          <canvas
            ref={canvasRef}
            width={960}
            height={540}
            className="bg-black h-full w-auto max-w-full max-h-full aspect-video object-contain"
          />
          {showSafeArea && (
            <div className="aspect-video w-full absolute">
              <div className='absolute top-0 left-0 right-0 bottom-0 border border-white/80'/>
              <div className='absolute top-[5%] left-[5%] right-[5%] bottom-[5%] border border-white/40'/>
              <div className='absolute top-[10%] left-[10%] right-[10%] bottom-[10%] border border-white/30'/>
            </div>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="p-1.5 rounded bg-secondary text-secondary-foreground hover:bg-secondary/80 hover:text-secondary-foreground outline-none">
                <FiSettings className="w-4 h-4" />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuCheckboxItem className="text-xs" checked={showSafeArea} onCheckedChange={setShowSafeArea}>
                Safe Area
              </DropdownMenuCheckboxItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
}

